angular.module('unica_room.room_controllers')

.controller('RoomEditController', function(
	$rootScope, $scope, $state, $stateParams,
	RoomEditService
) {

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getHotelList();

	$rootScope.getRoom( $stateParams.id );

	$scope.roomTypes = {};
	$scope.$on('hotel_list_loaded', function() {
		angular.forEach( $rootScope.hotelList, function(el) {
			$scope.roomTypes[ el.id ] = el.room_types;
		});
	});

	$scope.saveRoom = function() {
		$scope.showLoader();

		RoomEditService
			.update($rootScope.roomData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Stanza aggiornata con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});